import { render } from "./QnaSetting.vue?vue&type=template&id=be97ba0e&scoped=true"
import script from "./QnaSetting.vue?vue&type=script&lang=js"
export * from "./QnaSetting.vue?vue&type=script&lang=js"

import "./QnaSetting.vue?vue&type=style&index=0&id=be97ba0e&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be97ba0e"]])

export default __exports__